import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

const RoutePlanPickupSlots = ({ formData, onChange }) => {
  const [pickupSlots, setPickupSlots] = useState([]);

  useEffect(() => {
    setPickupSlots(formData || []);
  }, [formData]);

  const onFieldChange = (index, fieldName, newValue) => {
    const newPickupSlots = [...pickupSlots];
    newPickupSlots[index][fieldName] = newValue;
    setPickupSlots(newPickupSlots);
    onChange(newPickupSlots);
  };

  const addPickupSlot = () => {
    const newPickupSlots = [
      ...pickupSlots,
      { pickupFromHour: '', pickupFromMinutes: '', pickupToHour: '', pickupToMinutes: '' },
    ];
    setPickupSlots(newPickupSlots);
    onChange(newPickupSlots);
  };

  const removePickupSlot = (index) => {
    const newPickupSlots = [...pickupSlots];
    newPickupSlots.splice(index, 1);
    setPickupSlots(newPickupSlots);
    onChange(newPickupSlots);
  };

  return (
    <div className="form-block">
      <h5 className="m-b-2">
        ⏱ <FormattedMessage id="route.plan.form.field.pickup.slots.label" />
      </h5>

      <div className="m-b-3">
        {pickupSlots.map((pickupSlot, index) => {
          return (
            <div className="route-plan-form__pickup-slots-slot m-b-2" key={index}>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.pickup.slot.pickup.from.hour.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder="12"
                      type="text"
                      value={pickupSlot.pickupFromHour}
                      onChange={(e) => onFieldChange(index, 'pickupFromHour', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.pickup.slot.pickup.from.minutes.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder="00"
                      type="text"
                      value={pickupSlot.pickupFromMinutes}
                      onChange={(e) => onFieldChange(index, 'pickupFromMinutes', e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.pickup.slot.pickup.to.hour.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder="12"
                        type="text"
                        value={pickupSlot.pickupToHour}
                        onChange={(e) => onFieldChange(index, 'pickupToHour', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.pickup.slot.pickup.to.minutes.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder="15"
                        type="text"
                        value={pickupSlot.pickupToMinutes}
                        onChange={(e) => onFieldChange(index, 'pickupToMinutes', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <button onClick={() => removePickupSlot(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'route.plan.form.field.pickup.slots.remove'} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="btn btn-normal-link m-b-1" onClick={addPickupSlot}>
        <small>
          <FontAwesomeIcon icon={faClock} /> <FormattedMessage id={'route.plan.form.field.pickup.slots.add'} />
        </small>
      </div>
    </div>
  );
};

export default RoutePlanPickupSlots;
